/* call me puppy: Land- und Sprachauswahl + einmaliger Sprach-Hinweis (Markup: snippets/cmp-localization.liquid).
   Keine Texte im JS: alles kommt aus dem Liquid-Markup (locales) bzw. per Section Rendering API. */
(function () {
  var modal = document.getElementById('cmp-loc');
  var form = document.getElementById('cmp-loc-form');
  if (!modal || !form) return;
  var hint = document.getElementById('cmp-lhint');
  var KEY = 'cmp-lang-choice';
  var root = document.documentElement;
  var curCountry = modal.getAttribute('data-country');
  var curLang = modal.getAttribute('data-lang');
  var panel = modal.querySelector('.cmp-loc__panel');
  var backBtn = modal.querySelector('[data-cmp-loc-back]');
  var stepCountry = modal.querySelector('[data-step="country"]');
  var stepLang = modal.querySelector('[data-step="language"]');
  var langGrid = modal.querySelector('[data-cmp-loc-langs]');
  var openEl = null;
  var lastFocus = null;
  var picked = null;

  // Warenkorb je Sprache: Sets speichern Namen in der Bestellsprache → bei anderer Sprache Warenkorb leeren
  var cartCount = parseInt(modal.getAttribute('data-cart-count'), 10) || 0;
  var cartLang = modal.getAttribute('data-cart-lang');
  var clearUrl = modal.getAttribute('data-cart-clear') + '.js';
  var updateUrl = modal.getAttribute('data-cart-update') + '.js';
  function post(url, body) {
    return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body || {}) });
  }
  function tagCart() { return post(updateUrl, { attributes: { _cmp_lang: curLang } }); }
  if (!window.Shopify || !window.Shopify.designMode) {
    if (cartCount > 0 && cartLang && cartLang !== curLang) {
      // Sprache wurde ohne Modal gewechselt (Link, Weiterleitung): leeren, markieren, Seite mit leerem Warenkorb neu laden
      post(clearUrl).then(tagCart).then(function () { location.reload(); }).catch(function () {});
    } else if (cartLang !== curLang && (cartCount > 0 || cartLang)) {
      // Befüllter Warenkorb ohne Sprache → merken; leerer Warenkorb mit veralteter Sprache → aktualisieren,
      // sonst würde der nächste Artikel beim folgenden Seitenaufruf fälschlich gelöscht. Neuer leerer Warenkorb → keine Anfrage.
      tagCart().catch(function () {});
    }
  }

  // Fixed-Overlays direkt ans <body> (nicht in Section-Containern mit transform/overflow stecken lassen)
  [modal, hint].forEach(function (el) { if (el && el.parentElement !== document.body) document.body.appendChild(el); });

  function remember(v) { try { localStorage.setItem(KEY, v); } catch (e) {} }
  function remembered() { try { return localStorage.getItem(KEY); } catch (e) { return 'blocked'; } }

  function focusables(el) {
    return Array.prototype.filter.call(
      el.querySelectorAll('button, [href], input, select, [tabindex]:not([tabindex="-1"])'),
      function (n) { return !n.disabled && n.offsetParent !== null; }
    );
  }

  function open(el, focusTarget) {
    if (openEl && openEl !== el) close(openEl, true);
    lastFocus = document.activeElement;
    openEl = el;
    el.hidden = false;
    root.classList.add('cmp-loc-lock');
    requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.add('is-open'); }); });
    var f = focusTarget || focusables(el)[0];
    if (f) f.focus({ preventScroll: true });
  }

  function close(el, keepLock) {
    if (!el || el.hidden) return;
    el.classList.remove('is-open');
    if (openEl === el) openEl = null;
    if (!keepLock) root.classList.remove('cmp-loc-lock');
    setTimeout(function () { if (!el.classList.contains('is-open')) el.hidden = true; }, 250);
    if (!keepLock && lastFocus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
  }

  function showStep(lang) {
    stepCountry.hidden = lang;
    stepLang.hidden = !lang;
    backBtn.hidden = !lang;
    panel.setAttribute('aria-labelledby', lang ? 'cmp-loc-t-language' : 'cmp-loc-t-country');
    panel.scrollTop = 0;
    var cur = (lang ? stepLang : stepCountry).querySelector('.cmp-loc__opt[aria-current="true"]:not([hidden])');
    var first = cur || (lang ? stepLang : stepCountry).querySelector('.cmp-loc__opt:not([hidden])');
    if (first) first.focus({ preventScroll: true });
  }

  function submit(country, lang) {
    remember(lang || curLang);
    if (country === curCountry && (!lang || lang.toLowerCase() === curLang)) { close(openEl); return; }
    form.elements.country_code.value = country;
    if (lang) form.elements.language_code.value = lang;
    // Sprachwechsel: Warenkorb vorher leeren (siehe oben), dann wechseln. Aktuellen Stand abfragen, da seit dem
    // Seitenaufruf per AJAX etwas hinzugekommen sein kann.
    if (lang && lang.toLowerCase() !== curLang) {
      var cartJs = clearUrl.replace(/\/clear\.js$/, '.js');
      fetch(cartJs, { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (c) { if (c.item_count > 0) return post(clearUrl); })
        .catch(function () {})
        .then(function () { form.submit(); });
      return;
    }
    form.submit();
  }

  function pickCountry(btn) {
    picked = btn.getAttribute('data-cmp-loc-country');
    var langs = (btn.getAttribute('data-langs') || '').split(',').filter(Boolean);
    if (langs.length < 2) {
      var only = langs[0] && langGrid.querySelector('[data-cmp-loc-lang="' + langs[0] + '"]');
      submit(picked, only ? only.getAttribute('data-code') : null);
      return;
    }
    // Sprachen des Landes in Zuordnungs-Reihenfolge zeigen, übrige ausblenden
    Array.prototype.forEach.call(langGrid.children, function (b) { b.hidden = true; b.removeAttribute('aria-current'); });
    langs.forEach(function (code) {
      var b = langGrid.querySelector('[data-cmp-loc-lang="' + code + '"]');
      if (!b) return;
      b.hidden = false;
      if (code === curLang) b.setAttribute('aria-current', 'true');
      langGrid.appendChild(b);
    });
    showStep(true);
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    var opener = t.closest('[data-cmp-loc-open]');
    if (opener) {
      e.preventDefault();
      showStep(false);
      open(modal, stepCountry.querySelector('.cmp-loc__opt[aria-current="true"]'));
      return;
    }
    if (!openEl) return;
    if (t.closest('[data-cmp-loc-close]')) { close(modal); return; }
    if (t.closest('[data-cmp-loc-back]')) { showStep(false); return; }
    var c = t.closest('[data-cmp-loc-country]');
    if (c) { pickCountry(c); return; }
    var l = t.closest('[data-cmp-loc-lang]');
    if (l) { submit(picked || curCountry, l.getAttribute('data-code')); return; }
    if (t.closest('[data-cmp-lhint-stay]')) { remember(curLang); close(hint); return; }
    if (t.closest('[data-cmp-lhint-switch]')) { submit(curCountry, hint.getAttribute('data-code')); }
  });

  // Capture-Phase: ESC schließt nur diesen Dialog, nicht zusätzlich das Menü darunter
  window.addEventListener('keydown', function (e) {
    if (!openEl) return;
    if (e.key === 'Escape') {
      e.stopPropagation();
      if (openEl === hint) remember(curLang);
      close(openEl);
      return;
    }
    if (e.key !== 'Tab') return;
    // Fokus im offenen Dialog halten
    var list = focusables(openEl);
    if (!list.length) return;
    var first = list[0], last = list[list.length - 1];
    if (e.shiftKey && (document.activeElement === first || !openEl.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (document.activeElement === last || !openEl.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
  }, true);

  // Sprach-Hinweis: nur wenn Liquid ihn ausgegeben hat und noch nie beantwortet
  if (!hint || remembered()) return;
  function showHint() {
    if (remembered() || openEl) return;
    var shown = false;
    var go = function () { if (!shown && !openEl) { shown = true; open(hint); } };
    // Überschrift zusätzlich in der Landessprache: dieselbe locales-Übersetzung, von Shopify in dieser Sprache gerendert
    var base = (hint.getAttribute('data-root') || '/').replace(/\/?$/, '/');
    var foreign = hint.querySelector('[data-cmp-lhint-foreign]');
    var local = hint.querySelector('.cmp-lhint__local');
    fetch(base + '?sections=cmp-lang-hint', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var html = j && j['cmp-lang-hint'];
        if (!html) return;
        var tpl = document.createElement('template');
        tpl.innerHTML = html;
        var el = tpl.content.querySelector('[data-cmp-lhint-text]');
        var txt = el ? el.textContent.trim() : '';
        if (txt && txt !== local.textContent.trim()) { foreign.textContent = txt; foreign.hidden = false; }
      })
      .catch(function () {})
      .then(go);
    setTimeout(go, 2500);
  }
  var later = function () { setTimeout(showHint, 1200); };
  if (document.readyState === 'complete') later(); else window.addEventListener('load', later);
})();
